import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ProductCardContainer from './ProductCardContainer'
// import { api } from '../../../../api/integrationAPI'

import './ProductCards.scss'

export default class ProductCards extends Component {
  constructor (props) {
    // console.log('ProductCards constructor')
    super(props)

    this.state = {
      products: this.createProducts(props)
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    const isShowcasesNotEqual = this.props.showcases !== nextProps.showcases
    const isScenesNotEqual = this.props.scene !== nextProps.scene
    const isShownProductsNotEqual = this.props.productShown !== nextProps.productShown

    return isShowcasesNotEqual || isScenesNotEqual || isShownProductsNotEqual || this.state !== nextState
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.showcases !== nextProps.showcases) {
      this.setState({ products: this.createProducts(nextProps) })
    }
  }

  createProducts (props) {
    // console.log('createProducts', props)
    const { showcases, getProductInfo } = props
    const defaultProducts = showcases &&
      showcases.reduce((allProducts, showcase) => { // Get all the products from all the Showcases (cube scenes)
        return showcase.products ? allProducts.concat(showcase.products) : allProducts
      }, [])

    const res = []
    // console.log('defaultProducts', defaultProducts)
    // if (api && api.getProductInfo) {
    for (const p of defaultProducts) {
      const pInfo = getProductInfo(p)
      if (pInfo && pInfo.details) res.push(pInfo)
      if (!pInfo.details) console.log('-------------------->', pInfo)
    }
    // }
    // console.log('res products', res)

    return res
  }

  render () {
    // console.log('ProductCards render')
    const { scene, productShown, closeProduct, openSettings, closeSettings, prodMode } = this.props
    const { products } = this.state

    return (
      <div className={'in_products-cards' + (productShown ? ' in_products-cards-opened' : '')}>
        <div className={'in_products-cards-fade'} />
        {products && products.map((product, index) =>
          <ProductCardContainer
            // key={product.id}
            key={index}
            product={product}
            scene={scene}
            productShown={productShown}
            closeProduct={closeProduct}
            openSettings={openSettings}
            closeSettings={closeSettings}
            prodMode={prodMode}
          />
        )}
      </div>
    )
  }

  static propTypes = {
    showcases: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
    scene: PropTypes.string,
    productShown: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    closeProduct: PropTypes.func,
    openSettings: PropTypes.func,
    closeSettings: PropTypes.func,
    getProductInfo: PropTypes.func, // eslint-disable-line react/no-unused-prop-types
    prodMode: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/products/ProductCards.js